// AutoUpdater.js
import AvrgirlArduino from 'avrgirl-arduino';
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress, Typography} from '@mui/material';

const AutoUpdater = ({ serial, firmwareUrl, latestVersion, onComplete , logError}) => {
  const [open, setOpen] = useState(true);    // State to control dialog visibility
  const [loading, setLoading] = useState(false); // State to track loading progress
  const [message, setMessage] = useState('');    // State to display status messages


    // 0	Valid Digilab One board with UUID
  // 1	Failed to initially connect to the board
  // 2	Failed to get firmware from URL
  // 3	Failed to flash the board
  // 4	Failed to reconnect to the board after flashing
  // 5	Failed to generate a unique UUID not in the DB
  // 6	The board already has a UUID that is not valid
  // 7	The UUID flashing failed
  // 8	Failed to save board to DB
  // 9	Failed to save test result to DB
  // 10	Failed to query for UUID from DB
  // Start the firmware update process
  const startUpdate = async () => {
    setLoading(true); // Start loading
    try {
      // Check if the serial port is already open, and close it if necessary
      if (serial.port && serial.open) {
        console.log('[AutoUpdate] Closing existing port...');
        await serial.close();
      }

      // Request the specific CH340 serial port
      const filters = [
        { usbVendorId: 0x1A86, usbProductId: 0x7523 }, // Common CH340 device IDs
        { usbVendorId: 0x1A86, usbProductId: 0x55D4 }  // Another possible CH340 device ID
      ];

      //const filters = [{}];

      // Select the appropriat
      const ports = await navigator.serial.getPorts();

      //const selectedPort = await navigator.serial.requestPort({ filters });

      //console.log('[AutoUpdate] Found ports:', ports);

      
      const selectedPort = ports.find(port => filters.some(filter => {
        return port.getInfo().usbVendorId === filter.usbVendorId && port.getInfo().usbProductId === filter.usbProductId;
      }));

      if (!ports ) {
        setMessage('No CH340 device found. Please ensure the device is connected.');
        console.error('No CH340 device found.');
        setLoading(false);
        onComplete(false); // Indicate failure
        logError(1);
        return;
      }

      // Check if the port is already open
      if (selectedPort  !== undefined) {
        if (selectedPort.open) {
          console.log('[AutoUpdate] Port is already open. Skipping open step.');
        } else {
          console.log('[AutoUpdate] Opening the selected port...');
          await selectedPort.open({ baudRate: 9600 });
        }
    }

      const avrgirl = new AvrgirlArduino({
        board: 'nano (new bootloader)', // Specify the board type
        debug: true, // Enable debug mode
        serialPort: null, // Pass the serial port
      });

      // Fetch the hex file from the provided firmware URL
      console.log(`[AutoUpdate] Fetching firmware from ${firmwareUrl}`);
      const response = await fetch(firmwareUrl);
      if (!response.ok) {
        setMessage(`Failed to fetch firmware: ${response.statusText}`);
        console.error(`Failed to fetch firmware: ${response.statusText}`);
        setLoading(false);
        onComplete(false); // Indicate failure
        logError(2);
        return;
      }

      const filecontents = await response.arrayBuffer(); // Read the response as an array buffer

      // Flash the firmware using AvrgirlArduino
      avrgirl.flash(filecontents, (error) => {
        if (error) {
          console.error('Failed to update firmware:', error);
          setMessage('Firmware update failed.'); // Update message on failure
          setLoading(false); // Stop loading after the update process
          onComplete(false); // Indicate failure
          logError(3);
        } else {
          console.log('Firmware update complete');
          setMessage('Firmware update complete.');
          setTimeout(() => {
            setOpen(false); // Close the dialog
            onComplete(true); // Indicate success
          }, 2000);
          setLoading(false); // Stop loading after the update process
        }
      });
    } catch (error) {
      console.error('Failed to update firmware:', error);
      setMessage('Firmware update failed.'); // Display error message
      setLoading(false); // Stop loading
      onComplete(false); // Indicate failure
      logError(3);
    }
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Firmware Update</DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress /> // Show a loading spinner during the update
        ) : (
          <Typography>
            {message || `Firmware update is about to begin, please ensure the device remains connected.`}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        {!loading && !message && (
          <Button onClick={startUpdate} autoFocus>
            Continue
          </Button>
        )}
        {message && (
          <Button onClick={() => setOpen(false)}>
            Close
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AutoUpdater;
